import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import { MyCoursesView, coursesFiltersSchema } from '@/modules/courses'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute('/_auth/courses/my-courses')({
  validateSearch: search => coursesFiltersSchema.parse(search),
  component: () => <MyCoursesView />,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context }) => {
    const semesters = await context.queryClient.ensureQueryData(
      semesterQueryOptions({})
    )

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(
        search.semester,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/courses/my-courses',
        search: {
          ...search,
          semester: semesters.currentSemester?.id
        }
      })
    }
  },
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.courses', { ns: 'courses' }),
      i18n.t('title.my-courses-and-groups', { ns: 'courses' })
    ])
})
